// FIXME: temporary, react router is used here, but it should not in nextjs context
// eslint-disable-next-line import/no-extraneous-dependencies
import { useNavigate } from 'react-router';
import SearchIcon from '@mui/icons-material/Search';
import { getButtonLinkProps, ROUTES } from '@openclassrooms/routing';
import { getActiveLang, translate } from '@openclassrooms/translations';
import { localStorage } from '@openclassrooms/utils/local-storage';
import { styled } from '@classify/react-core-components/styles';
const SearchLink = styled('button')(({
  theme: {
    spacing,
    palette
  }
}) => ({
  display: 'flex',
  border: 'none',
  background: 'none',
  padding: 0,
  marginLeft: 'auto',
  marginRight: spacing(1),
  alignContent: 'center',
  justifyContent: 'center',
  cursor: 'pointer',
  '& svg': {
    width: 32,
    height: 32,
    color: palette.text.onMain
  },
  '&:hover': {
    '& svg': {
      color: palette.primary.main
    }
  }
}));
const SearchButton = () => {
  const isUrlLegacy = getButtonLinkProps(ROUTES.SEARCH.INDEX).component === 'a';
  let navigate: ReturnType<typeof useNavigate> | undefined;
  try {
    // prevent an error in Next.js context where useNavigate is not available
    // eslint-disable-next-line react-hooks/rules-of-hooks
    navigate = useNavigate();
  } catch {
    // Ignore errors when useNavigate is not available (e.g., in Next.js context)
  }
  async function handleClick(event: React.MouseEvent) {
    event.preventDefault();
    await localStorage.setItem('searchPageOriginUrl', globalThis.location.href);
    if (isUrlLegacy || !navigate) {
      globalThis.location.href = `/${getActiveLang()}${ROUTES.SEARCH.INDEX}`;
    } else {
      navigate(ROUTES.SEARCH.INDEX);
    }
  }
  return <SearchLink id="main-search" tabindex={0} onClick={handleClick} title={translate('global.hover.search')} aria-label={translate('global.word.search')}>
      <SearchIcon />
    </SearchLink>;
};
export default SearchButton;